import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Store for the auth prompt callback
let authPromptCallback = null;

export function setAuthPromptCallback(fn) {
  authPromptCallback = fn;
}

// Interceptor: on 401 for write ops, trigger auth prompt
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;

    // Skip auth endpoints
    if (original.url?.includes("/auth/")) {
      return Promise.reject(error);
    }

    // Try refresh first
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch {
        // Refresh failed — this is an unauthenticated user
        // For write operations (POST/PUT/DELETE), trigger auth prompt
        const method = original.method?.toLowerCase();
        if (method === "post" || method === "put" || method === "delete") {
          if (authPromptCallback) {
            authPromptCallback();
          }
        }
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
